import { Ajax } from '@shared/Ajax';


export const SavedViewAttachmentsService = {
    getAttachments: (savedViewUuid: string): JQueryPromise<any> => {
        return Ajax({
            url: `/api/1/saved-view/${savedViewUuid}/attachments`,
        })
    },

    deleteAttachment: (attachmentId: string, savedViewUuid: string): JQueryPromise<any> => {
        return Ajax({
            url: `/api/1/saved-view/${savedViewUuid}/attachment?attachmentId=${attachmentId}`,
            method: 'DELETE',
        })
    },

    addNewAttachment: (savedViewUuid: string, data: IAttachmentData): JQueryPromise<any> => {
        return Ajax({
            url: `/api/1/saved-view/${savedViewUuid}/attachments`,
            method: 'POST',
            data: data,
        })
    }
}
